import { useEffect } from "react";

const TITLE = "Mamy Kongres | 2027";

export default function useDocumentTitle(title, description) {
  useEffect(() => {
    document.title = TITLE;
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", "description");
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", description);
    }
    // Also keep og:title in sync
    let og = document.querySelector('meta[property="og:title"]');
    if (og) og.setAttribute("content", TITLE);
  }, [title, description]);
}
